import axios from 'axios';

export default class APIProxy {
  _instance;

  constructor() {
    this.axiosInstanceInternal = null;
    this.baseURL = 'https://osm.ayudax.com/geofences/';
  }

  static get instance() {
    if (!this._instance) {
      this._instance = new APIProxy();
    }
    return this._instance;
  }

  static reset() {
    APIProxy.instance.axiosInstanceInternal = null;
  }

  get axiosInstance() {
    if (this.axiosInstanceInternal === null) {
      this.axiosInstanceInternal = axios.create({
        baseURL: this.baseURL,
        headers: {
          'x-api-key': 'sKd0cbAPEo3YlzKCPNq3JFrTVmQ5t4u3yrYoKYR4',
        },
      });
    }
    return this.axiosInstanceInternal;
  }

  runGeofenceQuery(placeName, minLat, maxLat, minLng, maxLng, successCallback, errorCallback) {
    const config = {
      params: {
        placeName,
        minLat,
        maxLat,
        minLng,
        maxLng,
      },
    };
    this.axiosInstance.get('runGeofenceQuery', config).then(
      (successResponse) => {
        successCallback(successResponse.data);
      },
      (errorResponse) => {
        errorCallback(errorResponse.message);
        console.error(JSON.stringify(errorResponse.message));
      },
    );
  }

  getGeofenceQueryResults(queryExecutionId, successCallback, errorCallback) {
    this.axiosInstance
      .get('getGeofenceQueryResults', {
        params: {
          queryExecutionId,
        },
      })
      .then(
        (successResponse) => {
          successCallback(successResponse.data);
        },
        (errorResponse) => {
          errorCallback(errorResponse.message);
          console.error(JSON.stringify(errorResponse.message));
        },
      );
  }

  searchPlaces(placeName, minLat, maxLat, minLng, maxLng, bounded, successCallback, errorCallback) {
    const urlEncodedPlaceName = window.encodeURIComponent(placeName);
    const viewbox = `viewbox=${minLng}%2C${minLat}%2C${maxLng}%2C${maxLat}`;
    const url = bounded
      ? `https://nominatim.openstreetmap.org/search?q=${urlEncodedPlaceName}&format=json&polygon_geojson=1&limit=100&addressdetails=0&dedupe=1&bounded=1&${viewbox}`
      : `https://nominatim.openstreetmap.org/search?q=${urlEncodedPlaceName}&format=json&polygon_geojson=1&limit=100&addressdetails=0&dedupe=1`;
    // const url =
    // `https://nominatim.openstreetmap.org/search?q=${placeName}&format=json&polygon_geojson=1&limit=100&addressdetails=0&dedupe=1&bounded=1`; // eslint-disable-line
    axios
      .create()
      .get(url)
      .then(
        (successResponse) => {
          successCallback(successResponse.data);
        },
        (errorResponse) => {
          errorCallback(errorResponse.message);
          console.error(JSON.stringify(errorResponse.message));
        },
      );
  }
}
